module.exports = __webpack_public_path__ + "static/media/rules-r-en.1535ecb5.png";